import { createFileRoute } from '@tanstack/react-router';

/**
 * `?arrangement=<id>` — which engagement My Time shows (TT-V11 Phase 2b, FR-4, ADR-014).
 *
 * Passed through as an optional non-empty string; whether it names one of the caller's
 * arrangements is decided by `useEngagementSelection`, which removes a stale id. Every OTHER key is
 * returned untouched: `status` and the rest of the list-page state are owned by `useListPageState`
 * and must not be stripped here.
 */
export const Route = createFileRoute('/time/my-time')({
  validateSearch: (search: Record<string, unknown>): Record<string, unknown> & { arrangement?: string } => ({
    ...search,
    arrangement:
      typeof search.arrangement === 'string' && search.arrangement ? search.arrangement : undefined,
  }),
});
